'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _regulatorList = require('./regulator-list.component');

var _regulatorList2 = _interopRequireDefault(_regulatorList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.account.regulator-list', []).component('regulatorList', _regulatorList2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/companies/regulator-list/regulator-list.module.js